import { DialogProps } from '@mui/material/Dialog';
import { useTranslation } from 'react-i18next';

import EditorDialogShell from 'src/common/components/modals/EditorDialogShell';
import { IFormParticipant, IParticipant } from 'src/interfaces/Participant';
import ParticipantEditorForm from 'src/pages/Dashboard/Participants/forms/ParticipantEditorForm';

interface Props extends Omit<DialogProps, 'title'> {
  handleClose: () => void;
  handleSave: (editedParticipant: IFormParticipant) => void;
  isExternalSignup?: boolean;
  selectedParticipant?: IParticipant;
}

const ParticipantEditorModal = ({
  id,
  open,
  handleClose,
  handleSave,
  isExternalSignup = false,
  selectedParticipant,
}: Props) => {
  const { t } = useTranslation();
  const title = selectedParticipant
    ? t('participants.editParticipantModalTitle', {
        name: `${selectedParticipant.lastName} ${selectedParticipant.firstName}`,
      })
    : t('participants.addParticipantModalTitle');

  return (
    <EditorDialogShell
      id={id ?? 'participant-editor'}
      open={open}
      onClose={handleClose}
      title={title}
      fullScreen
    >
      <ParticipantEditorForm
        handleSave={handleSave}
        handleClose={handleClose}
        isExternalSignup={isExternalSignup}
        selectedParticipant={selectedParticipant}
      />
    </EditorDialogShell>
  );
};

export default ParticipantEditorModal;
